// Light, dark, or follow the device (system). The choice is a per-person, per-browser convenience (localStorage); the page falls back to "system" if
// storage is blocked. "system" removes the explicit attribute, so the stylesheet's prefers-color-scheme rule decides.
export type Theme = "light" | "dark" | "system";
const KEY = "hec.theme";

export function getTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch { return "system"; }
}

export function applyTheme(t: Theme): void {
  const root = document.documentElement;
  if (t === "system") root.removeAttribute("data-theme"); else root.setAttribute("data-theme", t);
}

export function setTheme(t: Theme): void {
  try { if (t === "system") localStorage.removeItem(KEY); else localStorage.setItem(KEY, t); } catch { /* the choice just will not survive a reload */ }
  applyTheme(t);
}
